
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceininternaatinaltech() {



    const cardData =
    {
        keyword: ' Corporate Cab Service in International Tech Park Chennai ITPC',
        heading: 'etravo : Corporate Cab Service in International Tech Park Chennai ITPC',



"headingDescription": "eTravo offers reliable Corporate Cab Services in International Tech Park Chennai (ITPC), designed for IT companies, MNCs, startups, and professionals who require seamless transportation for employee commuting, shift-based pickup and drop, airport transfers, client meetings, and executive travel. With GPS-enabled vehicles, experienced chauffeurs, and flexible corporate plans, eTravo ensures safe, punctual, and comfortable mobility across ITPC and surrounding IT corridors in Chennai.",

"top": "Top Corporate Cab Service Areas near International Tech Park Chennai (ITPC) with eTravo",

"topPlaces": [
  {
    "title": "International Tech Park Chennai (ITPC), Taramani",
    "description": "A major IT hub hosting global companies where structured employee pickup and drop services are essential for daily workforce commuting."
  },
  {
    "title": "Taramani IT Corridor",
    "description": "A key tech zone with multiple IT parks and offices requiring reliable corporate cab services for employees and executives."
  },
  {
    "title": "OMR (Old Mahabalipuram Road)",
    "description": "Chennai’s primary IT corridor connecting multiple tech hubs with high demand for employee transportation and business travel."
  },
  {
    "title": "Perungudi",
    "description": "A nearby IT and commercial hub supporting employee commuting to ITPC and other tech parks."
  },
  {
    "title": "Velachery",
    "description": "A major residential hub for IT professionals requiring daily office pickup and drop services."
  },
  {
    "title": "Thiruvanmiyur",
    "description": "A well-connected locality near ITPC with high demand for corporate commuting and executive travel."
  },
  {
    "title": "Adyar",
    "description": "A premium residential and commercial area where corporate professionals require daily travel solutions."
  },
  {
    "title": "Guindy to Airport Corridor",
    "description": "A key corporate travel route connecting ITPC to Chennai International Airport for executive transfers."
  },
  {
    "title": "Tidel Park",
    "description": "A nearby major IT hub requiring inter-office travel and employee transportation services."
  },
  {
    "title": "Siruseri SIPCOT IT Park",
    "description": "A large IT zone connected via OMR where corporate cab services are essential for workforce mobility."
  }
],


"services": [
{
"name": "Corporate Cab ITPC Chennai",
"description": "eTravo offers reliable corporate cab services in ITPC Chennai designed for smooth and professional business travel. Our service ensures punctual pickups, comfortable rides, and experienced chauffeurs for daily office commuting and executive travel."
},
{
"name": "Taxi International Tech Park Chennai",
"description": "Our taxi services in International Tech Park Chennai provide quick and dependable transportation for IT professionals. eTravo ensures clean vehicles, timely service, and hassle-free travel within the tech hub."
},
{
"name": "Company Cab ITPC",
"description": "eTravo provides company cab services in ITPC tailored for corporate needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Transport ITPC Chennai",
"description": "Simplify employee commuting with eTravo’s office transport services in ITPC Chennai. We offer structured and efficient transportation solutions for daily travel across IT offices."
},
{
"name": "Employee Cab ITPC",
"description": "Our employee cab services in ITPC are designed for safe and punctual commuting. eTravo ensures well-coordinated pickup and drop services for smooth daily travel."
},
{
"name": "Corporate Travel ITPC Chennai",
"description": "eTravo offers corporate travel services in ITPC Chennai for both local and outstation business needs. Our service ensures reliable and comfortable journeys for executives and teams."
},
{
"name": "Business Cab ITPC",
"description": "eTravo’s business cab services in ITPC are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality and professional travel experiences."
},
{
"name": "Staff Transport ITPC Chennai",
"description": "eTravo provides dependable staff transport services in ITPC Chennai for daily employee commuting. Our service ensures timely pickups, safe rides, and efficient coordination."
},
{
"name": "Corporate Taxi ITPC",
"description": "Our corporate taxi services in ITPC offer flexible and reliable transportation for businesses. eTravo ensures smooth travel for employees, executives, and corporate clients."
},
{
"name": "Company Taxi ITPC Chennai",
"description": "eTravo’s company taxi services in ITPC Chennai provide convenient travel solutions for corporate requirements. Our taxis are ideal for daily operations and client handling."
},
{
"name": "Corporate Pickup Drop ITPC",
"description": "eTravo offers corporate pickup and drop services in ITPC for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Office Cab Booking ITPC",
"description": "Book office cabs in ITPC easily with eTravo. Our reliable service ensures timely pickups, comfortable rides, and hassle-free travel for corporate teams."
},
{
"name": "Business Travel Cab ITPC",
"description": "Our business travel cab services in ITPC are designed for professionals traveling for meetings and corporate tasks. eTravo ensures smooth and efficient journeys."
},
{
"name": "Corporate Commute ITPC Chennai",
"description": "eTravo’s corporate commute services in ITPC Chennai provide structured and dependable employee transportation. Our service ensures smooth daily travel for corporate staff."
},
{
"name": "Professional Cab ITPC",
"description": "eTravo offers professional cab services in ITPC with trained drivers and well-maintained vehicles. Our service ensures safe, comfortable, and reliable travel for all business needs."
}
],
"tableData": [
["Corporate Cab ITPC Chennai", "Taxi International Tech Park Chennai"],
["Company Cab ITPC", "Office Transport ITPC Chennai"],
["Employee Cab ITPC", "Corporate Travel ITPC Chennai"],
["Business Cab ITPC", "Staff Transport ITPC Chennai"],
["Corporate Taxi ITPC", "Company Taxi ITPC Chennai"],
["Corporate Pickup Drop ITPC", "Office Cab Booking ITPC"],
["Business Travel Cab ITPC", "Corporate Commute ITPC Chennai"],
["Professional Cab ITPC", ""]
],



"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab Service in International Tech Park Chennai ITPC",
      "WhyChoosedescription": "eTravo offers dependable corporate cab services in International Tech Park Chennai (ITPC), ensuring smooth and efficient transportation for IT professionals, executives, and corporate teams."
    },
    {
      "WhyChooseheading": "Ideal for ITPC Taramani Business Hub",
      "WhyChoosedescription": "International Tech Park Chennai (ITPC) is a major IT hub located in Taramani with over 40 IT/ITES companies and extensive office space, making structured corporate transport essential for workforce mobility. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Daily Employee Pickup and Drop Services",
      "WhyChoosedescription": "Corporate cab services provide organized daily pickup and drop with optimized routes, ensuring employees reach offices on time and improving operational efficiency."
    },
    {
      "WhyChooseheading": "Flexible Shift-Based Transportation Solutions",
      "WhyChoosedescription": "IT companies in ITPC operate across multiple shifts, and cab services ensure safe and timely commuting for day, night, and rotational employees. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate Travel Needs",
      "WhyChoosedescription": "We provide hatchbacks, sedans, SUVs, and larger vehicles suitable for employee commute, executive travel, and group transportation requirements."
    },
    {
      "WhyChooseheading": "Technology-Driven Fleet and Real-Time Tracking",
      "WhyChoosedescription": "Corporate cab services use GPS tracking, route optimization, and centralized monitoring systems to ensure safety, transparency, and efficiency in employee transport. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Local Expertise",
      "WhyChoosedescription": "Experienced drivers familiar with Taramani, OMR, Velachery, and surrounding areas ensure safe, punctual, and efficient travel for employees."
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Operations",
      "WhyChoosedescription": "Round-the-clock support ensures seamless coordination, quick issue resolution, and uninterrupted corporate mobility for businesses in ITPC Chennai."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is corporate cab service in ITPC Chennai?',
            answer: 'Corporate cab service in ITPC Chennai provides organized transportation for employees, executives, and clients including daily office commute and business travel.',
        },
        {
            question: 'Why are corporate cab services important in ITPC?',
            answer: 'ITPC is a major IT hub with multiple global companies, and reliable transportation ensures employees reach offices on time and improves productivity. :contentReference[oaicite:3]{index=3}',
        },
        {
            question: 'Do corporate cab services provide daily pickup and drop?',
            answer: 'Yes, services include structured daily pickup and drop with optimized routes and schedules for employees.',
        },
        {
            question: 'Can transportation be arranged for multiple shifts?',
            answer: 'Yes, corporate cab services support day, night, and rotational shifts with flexible scheduling. :contentReference[oaicite:4]{index=4}',
        },
        {
            question: 'What types of vehicles are available for corporate travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, buses, and larger vehicles depending on workforce size and requirements.',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols ensuring secure travel.',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, companies can customize routes, schedules, and rental plans based on workforce requirements.',
        },
        {
            question: 'Are corporate cab services available 24/7 in ITPC?',
            answer: 'Yes, most providers operate round the clock to support corporate travel and shift-based operations.',
        },
        {
            question: 'Do corporate cab services provide airport transfers?',
            answer: 'Yes, airport pickup and drop services are available for employees and corporate clients traveling from ITPC Chennai.',
        },
        {
            question: 'How can I book corporate cab service in ITPC Chennai?',
            answer: 'You can book through the service provider’s website or contact their support team for customized corporate transport solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Arvind Kumar',
        designation: 'Operations Manager, IT Company, ITPC Chennai',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has streamlined our employee transport in ITPC. Their punctual service and route planning make daily commuting smooth and efficient.”',
    },
    {
        name: 'Ms. Kavya Ramesh',
        designation: 'HR Manager, Tech Firm, Taramani Chennai',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for corporate cab services in ITPC. Their flexibility and reliable service ensure stress-free commuting for our employees.”',
    },
];




    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in International Tech Park Chennai ITPC",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-itpc-chennai.jpg",
  "description": "Reliable corporate cab services in International Tech Park Chennai (ITPC) by eTravo. Ideal for IT employee transport, office pickup and drop, business travel, corporate commute, and professional cab services with safe and timely rides.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-service-in-international-tech-park-chennai-itpc"
  }
};





    return (
        <div>

<Helmet>
  <title>Corporate Cab Service in ITPC Chennai | Office & IT Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab service in International Tech Park Chennai (ITPC) with eTravo for IT employee transport, office commute, business travel, and corporate pickup and drop services." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/161.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceininternaatinaltech;